import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';

export function RootLayout() {
  useEffect(() => {
    // Load WonderPush or other third-party scripts here
    // This replaces the script loading from Next.js app/layout.tsx
  }, []);

  return <Outlet />;
}
